import { useState } from "react";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";
import { adminApi } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

/** Hard-deletes a submission (and its quote) after a confirm step. */
export const DeleteRequestButton = ({ request, onDeleted, compact }) => {
  const [busy, setBusy] = useState(false);
  const del = async () => {
    setBusy(true);
    try { await adminApi.deleteRequest(request.request_id); toast.success(`Deleted ${request.order_no || request.request_id}`); onDeleted?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Delete failed"); }
    setBusy(false);
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button disabled={busy} data-testid={`request-delete-${request.request_id}`}
          className={`inline-flex items-center gap-1 rounded-sm border border-[#E3000B]/40 text-[#E3000B] font-mono uppercase hover:bg-[#E3000B]/10 disabled:opacity-50 ${compact ? "h-7 px-2 text-[10px]" : "h-8 px-3 text-xs"}`}>
          <Trash size={12} /> Delete
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-white border-[#E4E4E0]" data-testid="request-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-head">Delete {request.order_no || "this submission"}?</AlertDialogTitle>
          <AlertDialogDescription className="font-mono text-xs text-gray-600">
            Removes the request, its quote, the customer's invoice link and their account history entry. This can't be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="font-mono text-xs" data-testid="request-delete-cancel">Keep it</AlertDialogCancel>
          <AlertDialogAction onClick={del} className="bg-[#E3000B] text-white font-mono text-xs hover:bg-[#B8000A]" data-testid="request-delete-confirm">Delete permanently</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
